import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Campaign } from '../../../../types/campaign';
import { updateCampaignClickTag } from '../../../../api/campaignApi';
import { Loader2 } from 'lucide-react';

interface UpdateCampaignClickTagModalProps {
    campaign: Campaign;
    isOpen: boolean;
    toggle: () => void;
    onUpdateData: (data: Campaign) => void;
}

const UpdateCampaignClickTagModal = ({ campaign, isOpen, toggle, onUpdateData }: UpdateCampaignClickTagModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const toggleModal = () => {
        toggle();
    };

    const handleForm: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            file: undefined,
        },
        validationSchema: Yup.object({
            file: Yup.mixed().required("É necessário um arquivo csv")
        }),
        onSubmit: (values: any) => {
            setLoading(true);
            const formData = new FormData();
            const file: HTMLInputElement | null = document.querySelector('#file-field');
            if (file && file.files) {
                formData.append('file', file.files[0]);
            }
            updateCampaignClickTag(campaign.id, formData)
                .then((res: any) => {
                    toggleModal();
                    onUpdateData(res);
                    toast.success('Campanha atualizada com sucesso!');
                })
                .catch(() => {
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    return (
        <Dialog open={isOpen} onOpenChange={toggleModal}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Atualizar URL dos pedidos</DialogTitle>
                    <DialogDescription>
                        Faça upload de um arquivo CSV com as URLs dos pedidos.
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleForm.handleSubmit();
                    return false;
                }}>
                    <div className="grid gap-4 py-4">
                        <div className="grid gap-2">
                            <Label htmlFor="file-field">Pedidos</Label>
                            <Input
                                type="file"
                                id="file-field"
                                name="file"
                                accept=".csv"
                                onChange={handleForm.handleChange}
                                onBlur={handleForm.handleBlur}
                                value={handleForm.values.file}
                            />
                            {handleForm.touched.file && handleForm.errors.file && (
                                <p className="text-sm text-red-500">{handleForm.errors.file}</p>
                            )}
                        </div>
                    </div>
                    <DialogFooter>
                        <Button type="submit" disabled={loading}>
                            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                            Atualizar
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default UpdateCampaignClickTagModal;